<div>
  <!-- Main Header -->
  <app-main-header
    [backgroundImage]="customBackgroundImage || data.bannerImageUrl"
    [showHeaderButtons]="true"
    [isImage]="false"
    >
  </app-main-header>

  <div class="main-container">
    <!-- Main Header Section -->
    <section class="page-header page-header-classic no-margin page-header-main main_back_image"
      [style.background-image]="'url(' + data.bannerImageUrl + ')'">
      <div class="container">

        <!-- Top Row (Empty for now, can be used for announcements) -->
        <div class="row">
          <div class="col">
          </div>
          <div class="col-md-3 text-right">
          </div>
        </div>

        <!-- Title and Social Links Row -->
        <div class="row align-items-center">

          <div class="col-md-9 p-static">
            <br />
            <br />
            <h1 [attr.data-title-border]="true"> {{ 'HEADER_TITLE' | translate }}</h1>
            @if (data.name) {
              <h2 class="subtitle"> {{ 'HEADER_SUBTITLE' | translate }}</h2>
            }
          </div>

          <div class="col-md-3 d-flex justify-content-end">
            <app-header-controls
              [socialLinks]="getSocialLinks()"
              [showLanguageSelector]="true"
              [showSocialLinks]="true">
            </app-header-controls>
          </div>
        </div>
      </div>
    </section>

    <!-- Navigation Header -->
    <div id="header" class="header-journal">
      <div class="header-nav-bar header-nav-bar-top-border bg-light">
        <div class="header-container container">
          <div class="header-row">
            <div class="header-column">
              <div class="header-row justify-content-end">
                <div class="header-nav p-0">
                  <div class="header-nav header-nav-line header-nav-divisor header-nav-spaced">
                    <div id="header-sub"
                      class="header-nav-main header-nav-main-square header-nav-main-effect-1 header-nav-main-sub-effect-1">
                      <nav class="collapse" id="header-sub-nav">
                        <ul class="nav nav-pills flex-column flex-lg-row" id="mainNav">
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle" (click)="navigateToHome(); $event.preventDefault()">
                              {{ 'MENU_HOME' | translate }}
                            </a>
                          </li>
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle" (click)="navigateToJournals(); $event.preventDefault()">
                              {{ 'MENU_JOURNALS' | translate }}
                            </a>
                          </li>
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle" (click)="navigateToBooks(); $event.preventDefault()">
                              {{ 'MENU_BOOKS' | translate }}
                            </a>
                          </li>
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle" (click)="navigateToSeries(); $event.preventDefault()">
                              {{ 'MENU_SERIES' | translate }}
                            </a>
                          </li>
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle" (click)="navigateToConferences(); $event.preventDefault()">
                              {{ 'MENU_CONFERENCES' | translate }}
                            </a>
                          </li>
                          <li class="dropdown">
                            <a href="#" class="dropdown-item dropdown-toggle anniversary-link"
                              (click)="navigateTo100Anniversary(); $event.preventDefault()">
                              {{ 'MENU_100ANNIVERSARY' | translate }}
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <button class="btn btn-sm  header-btn-collapse-nav" type="button" (click)="toggleMobileNav()"
                      data-bs-toggle="collapse" data-bs-target="#header-sub-nav">
                      <i class="fas fa-bars"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>